module.exports = __webpack_public_path__ + "static/web-bc1cdfe47ee7fcbe588fe9e82630c031.svg";